export default "__VITE_ASSET__UHR9HwuP__"